export default __webpack_public_path__ + "static/media/mens-bottom.82a77bb5.png";